import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";

export const Vatform = ({
  rootFormDetails,
  setRootFormDetails,
  validation,
}) => {
  const {
    control,
    formState: { errors },
    trigger,
  } = validation;

  return (
    <section className={`${globalStyles.cardWithBorder} light-bg`}>
      <p>VAT</p>

      <div
        className="d-flex justify-content-between align-items-center flex-wrap mt-3"
        style={{ gap: "15px" }}
      >
        <div>
          <div>
            <primaryComponents.Checkbox
              name="vatEnabled"
              id="vat_enabled"
              isChecked={rootFormDetails?.vat_enabled}
              onChange={() => {
                setRootFormDetails((prev) => ({
                  ...prev,
                  vat_enabled: !rootFormDetails?.vat_enabled,
                  vat: rootFormDetails?.vat_enabled
                    ? "0"
                    : rootFormDetails?.vat,
                  include_vat_in_price: rootFormDetails?.vat_enabled
                    ? false
                    : rootFormDetails?.include_vat_in_price,
                }));
              }}
            >
              <span className="mt-1 d-block">Enable VAT for this product</span>
            </primaryComponents.Checkbox>
          </div>
          {rootFormDetails?.vat_enabled && (
            <div
              className={`${globalStyles.cardWithBackground} align-items-center flex-row white mt-3`}
              style={{ gap: "15px" }}
            >
              <span style={{ fontSize: "13px" }}>
                Is VAT included in your selling price?
              </span>

              <secondaryComponents.ToolTipV2 tipText="When this is set to Yes, the selling price you enter already includes VAT. At checkout, the customer will pay and see only the total VAT-inclusive price on the sales receipt, without a VAT breakdown. We will still record the VAT portion internally for compliance and reporting.">
                <primaryComponents.RadioButton
                  name={"vatInclusive"}
                  id={"include_vat_in_price_yes"}
                  checked={rootFormDetails?.include_vat_in_price}
                  setRadioValue={() => {
                    setRootFormDetails((prev) => ({
                      ...prev,
                      include_vat_in_price: true,
                    }));
                  }}
                >
                  Yes
                </primaryComponents.RadioButton>
              </secondaryComponents.ToolTipV2>

              <secondaryComponents.ToolTipV2 tipText="When this is set to No, the selling price you enter is before VAT. At checkout, we will calculate VAT and add it to the price, so the customer’s sales receipt will show the VAT amount and the final total. We will also record the VAT for compliance and reporting.">
                <primaryComponents.RadioButton
                  name={"vatInclusive"}
                  id={"include_vat_in_price_no"}
                  checked={!rootFormDetails?.include_vat_in_price}
                  setRadioValue={() => {
                    setRootFormDetails((prev) => ({
                      ...prev,
                      include_vat_in_price: false,
                    }));
                  }}
                >
                  No
                </primaryComponents.RadioButton>
              </secondaryComponents.ToolTipV2>
            </div>
          )}
        </div>

        <div style={{ width: "200px" }}>
          <primaryComponents.PercentageInputFieldV2
            name="vat"
            control={control}
            percentBg={"#E4DAFC"}
            percentColor={"#7647EE"}
            placeholder="Enter VAT Value"
            type="number"
            min={0}
            step={0.01}
            value={rootFormDetails.vat}
            isDisabled={rootFormDetails.vat_enabled !== true}
            floatError={false}
            errorMessage={errors?.vat}
            onKeyUp={() => errors?.vat && trigger("vat")}
            onChange={({ target: { value } }) =>
              setRootFormDetails((prev) => ({
                ...prev,
                vat: value,
              }))
            }
          />
        </div>
      </div>
    </section>
  );
};
